var REQUEST_TIMEOUT = 5000;
var REQUEST_RETRY_COUNT = 2;

function _request(url, parameters, isPOST) {
    if(isPOST){
        return $.post({
            url: url,
            data: parameters
        });
    }
    return $.get({
        url: url,
        data: parameters,
        timeout: REQUEST_TIMEOUT
    });
}

function _retryRequest(url, parameters, resolve, reject, isPOST, retryNumber) {
    retryNumber = retryNumber || 0;

    _request(url, parameters, isPOST)
        .done(resolve)
        .fail(function(data) {
            if(retryNumber < REQUEST_RETRY_COUNT) {
                retryNumber++;
                _retryRequest(url, parameters, resolve, reject, retryNumber, isPOST);
            } else {
                reject(data);
            }
        });
}

/**
 * Make a reliable request
 * When it fails it is retried up to REQUEST_RETRY_COUNT times
 * @param  {String} url
 * @param  {Object} parameters
 * @param  {Boolean} isPOST
 * @return {Promise}
 */
function _reliableRequest(url, parameters, isPOST) {
    // return new Promise(function(resolve, reject) {
    //     _retryRequest(url, parameters, resolve, reject);
    // });
    var deferred = new $.Deferred();
    _retryRequest(url, parameters, deferred.resolve, deferred.reject, isPOST);
    return deferred;
}

module.exports = {
    reliableRequest: _reliableRequest
};


//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/validation/common/validation-utils.js
// module id = 29
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 16 19 21 24 25